import React, { Component } from 'react';
import Header from '../partials/header';
import Session from '../services/session'
import Footer from '../partials/Footer';
import Banner from '../partials/Banner';
import {Card, CardsList} from '../components/cards';
import RequestBlock from '../partials/RequestBlock';
import {Helmet} from 'react-helmet';

import i from '../imports';



class BasePage extends Component {

    constructor(props) {
        super(props);
    }

   
    render() {
        return (
            <div className="App" style={{overflowX: "hidden"}}>
                                       
                <Helmet>
                    <title>{this.props.data.title}</title>

                    <meta name="keywords" content={findSeo(this.props.data,"seo_keywords")} />
                    <meta name="description" content={findSeo(this.props.data,"seo_description")} />
                </Helmet>
                
                <Header/>
                
                <i.OnMobile>
                    <div style={{zIndex: -900, margin: "0px 20px"}}>
                        <div>
                            {this.props.children}
                        </div>
                    </div> 
                </i.OnMobile>
                <i.OnAtLeastPhablet>
                    <div style={{zIndex: -900}}>
                        <div>
                            {this.props.children}
                        </div>
                    </div> 
                </i.OnAtLeastPhablet>     
                              
                <RequestBlock/>
                <Footer />
                
                
                <script>
                    `
                    $(window).trigger('resize');
                    `
                </script>
            </div>
        );
    }
}

const findSeo = (item, type) => {
    if(item.translations != undefined)
        if(item.translations.length > 0 && item.translations[0].seoblock != undefined)
            return item.translations[0].seoblock[type] == undefined ? "" : item.translations[0].seoblock[type];
        else
            return "";
    else
        if(item.seoblock != undefined)
            return item.seoblock[type] == undefined ? "" : item.seoblock[type];
        else
            return "";

}

export default BasePage;


